
const Module = require('module');
const getNamespace = require('boring-cls').getNamespace;
const path = require('path');
const logger = require('boring-logger');
const makeRelative = require('make-relative-path');

let inited = false;
let webpackStats;

function init() {

  if (inited) return;

  const originalRequire = Module.prototype.require;
  Module.prototype.require = function() {
    // eslint-disable-next-line prefer-rest-params
    const args = Array.prototype.slice.apply(arguments);
    const fileName = (args[0]|| '').toLowerCase();

    // for css don't blow up and move on
    if (fileName.endsWith('.css') || fileName.endsWith('.scss')) return {};
    if (fileName.endsWith('.jpg') ||
        fileName.endsWith('.jpeg') ||
        fileName.endsWith('.svg') ||
        fileName.endsWith('.png') ||
        fileName.endsWith('.gif') ||
        fileName.endsWith('.webp')) {

      const ns = getNamespace('http-request');
      const reactHandlerPaths = ns.get('reactHandlerPaths');

      if (reactHandlerPaths && Object.keys(reactHandlerPaths).length) {

        const parts = this.id.split('/');
        // get rid of the filename
        parts.pop();

        const id = makeRelative(process.cwd(), path.normalize(parts.join('/') + '/' + fileName)).toLowerCase();

        if (webpackStats && webpackStats.modules) {

          const modules = webpackStats.modules.filter(module => {
            if (module && module.id && typeof module.id === 'string') {
              return (module.id.toLowerCase() === id ||
                module.id.toLowerCase() === id.replace('/dist', '/src'));
            }
            return false;
          });

          if (modules.length === 1 && modules[0].assets.length === 1) {
            return '/' + modules[0].assets[0];
          } else logger.debug(`Did not resolve module properly for ${id}`);

        }

        // default 1 x 1 transparent gif
        return 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

      }
    }

    let retVal;
    try {
      retVal = originalRequire.apply(this, args);
    } catch (e) {
      /**
       * This try catch here is nice because it will essentially
       * create a deep stack trace of the module that is throwing
       * to the module that is calling on the root
       */
      logger.warn('ERROR REQUIREING MODULE', args);
      throw e;
    }

    return retVal;
  };

  inited = true;

}
init();

function registerWebpackStats(stats) {
  webpackStats = stats;
}

module.exports = {
  registerWebpackStats,
};
